import { render, staticRenderFns } from "./PackagePay.vue?vue&type=template&id=8c47860e&scoped=true"
import script from "./PackagePay.vue?vue&type=script&lang=js"
export * from "./PackagePay.vue?vue&type=script&lang=js"
import style0 from "./PackagePay.vue?vue&type=style&index=0&id=8c47860e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c47860e",
  null
  
)

export default component.exports